<template>
  <div id="app">
    <comheader></comheader>
    <comsidebar></comsidebar>
    <div class="com-main">
      <router-view :key="$route.path"></router-view>
    </div>
    <comfooter></comfooter>
  </div>
</template>
<script>
import comheader from '@/components/comheader/index'
import comsidebar from '@/components/comsidebar/index'
import comfooter from '@/components/comfooter/index'

export default {
  components: {
    comheader,
    comsidebar,
    comfooter,
  },
  data() {
    return {
      dataloading: '',

    }
  },
  created() {
    this.loadingAll()
    // this.dataRequestindex_seo()
  },
  methods: {

    loadingAll() {
      let that = this
      that.dataloading = that.$loading({
        lock: true,
        // text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'transparent'
      });
      let timer = setInterval(function () {
        if (document.readyState === 'complete') {
          that.dataloading.close();
          window.clearInterval(timer)
        }
      }, 500)
    },
  }
}
</script>
<style lang="scss">
.el-loading-mask {
  .el-loading-spinner {
    font-size: 40px;

  }
}
</style>
